export const DRAW_EVENTS = {
    /** 绘制配置变化 */
    CONFIG_CHANGE: 'markup-config-change',
    /** 绘制结束 */
    DRAW_END: 'markup-draw-end',
};
